var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 19.006 19.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13093",
    "data-name": "Group 13093",
    transform: "translate(-1166.055 -174.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11337",
    "data-name": "Path 11337",
    d: "M-15385.53,2960.219l16.178,16.178",
    transform: "translate(16553 -2784)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11338",
    "data-name": "Path 11338",
    d: "M-15369.353,2960.219l-16.178,16.178",
    transform: "translate(16553 -2784)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f52389de49589675a8f4aaf3271a0b88.svg";
export { ForwardRef as ReactComponent };